import React, { ReactElement } from 'react';
import { LinkButton } from '@finn-no/troika-react-buttons';

export interface LinkButtonTextFieldProps {
    id: string;
    label: string;
    type?: string;
    value: string;
    metric?: string;
    prefix?: string;
    showInput: boolean;
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
    onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    floatRight?: boolean;
    min?: number;
    max?: number;
}
export const LinkButtonTextField: React.FC<LinkButtonTextFieldProps> = ({
    id,
    label,
    type = 'string',
    value,
    metric = '',
    prefix = '',
    showInput,
    onClick,
    onChange,
    onBlur,
    onFocus,
    onKeyPress,
    floatRight,
}): ReactElement<LinkButtonTextFieldProps> => {
    const shouldFocus = React.useRef(false);

    const focusIfClicked = (element: HTMLInputElement): void => {
        if (shouldFocus.current) {
            element.focus();
            shouldFocus.current = false;
        }
    };

    return (
        (showInput && (
            <div className="input input--no-bottom-margin input--number">
                <label className="label" htmlFor={id}>
                    {label}
                </label>
                <input
                    id={id}
                    type={type}
                    data-testid={`LinkButtonTextField-input-${id}`}
                    value={value}
                    onChange={onChange}
                    onFocus={(event: React.FocusEvent<HTMLInputElement>): void => {
                        if (onFocus) onFocus(event);
                        event.target.select();
                    }}
                    onBlur={onBlur}
                    onKeyPress={onKeyPress}
                    ref={focusIfClicked}
                />
            </div>
        )) || (
            <LinkButton
                className={floatRight ? 'u-float-right' : ''}
                data-testid={`LinkButtonTextField-button-${id}`}
                onClick={(event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
                    if (onClick) onClick(event);
                    shouldFocus.current = true;
                }}>
                {prefix} {value} {metric}
            </LinkButton>
        )
    );
};
